<template>
    <div class="page white_bg">

        <header class="pageHeader white_bg bottomBorder101010" style="line-height: 46px;">
            <div class="flexLayout paddingH16">
                <div style="width: 16%">
                    <span class="icon leftAngleBracketIcon floatL" style="margin-top: 12px;" @click="back();"></span>
                </div>
                <div class="flexItem alignCenter font18r primaryTextColor bold"
                     style="height: 46px; overflow: hidden">
                    {{title}}
                </div>
                <div class="font14r alignRight" style="width: 16%">
                </div>

            </div>
            <div class="flexLayout paddingH16">
                <searchBox ref="searchBox" placeholder="搜索好课" :onClick="onClickSearchBox"/>
            </div>

        </header>

        <div>
            <tagMenuModule ref="tagMenuModule"/>
        </div>

        <div class="body">

            <div class="padding8">

                <div class="dataItem" v-for="dataItem in dataList"
                     :key="dataItem.id" v-if="dataItem.img" @click="viewItem(dataItem)">
                    <div class="">
                        <img class="fullSpace roundBorder8" height="auto" :src="dataItem.img"/>
                    </div>
                </div>

                <div class="alignCenter paddingV8" v-show="status === 'loading'">
                    <i class="icon spinner-loader"></i>
                </div>

                <div class="paddingV16 colorCCC font14r alignC"
                     v-show="status == 'ready' &&  dataList.length < 1">
                    暂无任何项目
                </div>

                <div class="paddingV16 alignCenter font14r colorCCC"
                     v-show="status=='ready' && pagination.current == pagination.totalPage"
                     :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                    没有更多项目了
                </div>

                <div class="paddingV16 colorCCC font14r alignC"
                     v-show="status == 'error'">
                    加载数据失败
                </div>

            </div>


        </div><!-- end .body -->

        <bottomMenu ref="bottomMenu" activePath="zhiye_jineng"/>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import searchBox      from '@comp/searchBox';
import tagMenuModule  from './tagMenuModule';
import bottomMenu     from '@comp/bottomMenu';

// config
import appConfig from '@/appConfig';

// util
import consoleApi        from '@/components/platformApi/consoleApi';
import appHelper        from '@/util/appHelper';
import dataMixedUtils   from "@/util/dataMixedUtils";
import {redirectBySkipType} from '@/components/shixunApp/toDetail';

const config = {
    name : 'zhiye_jineng',
    title : '职业技能',
    description : '',
    apiConfig : {
        list : {
            url : 'portal/tag/list',
            params : {
                type : 2
            },
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : { searchBox, tagMenuModule, bottomMenu },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            enableDataList : true,
            autoLoadDataList : appConfig.mode != 'demo'
        }
    },
    methods : {
        viewItem(dataItem) {

            if (dataItem.skipType == 33)
            {
                appHelper.goToPage('zhiye_jineng_list', {
                    id : dataItem.id
                });
            }
            else
            {
                redirectBySkipType(dataItem.skipType, {
                    skipAddress : dataItem.link,
                    skipParams : dataItem.skipParams,
                    id : dataItem.id,
                });
            }
        },
        onClickSearchBox: function () {
            consoleApi.log('[职业技能 page] 点击搜索栏，转到搜索页。');
            this.$router.push({name:'search'})
        }
    }
}
</script>

<style lang="scss" scoped>

.dataItem {
    margin-bottom: 10px;
}
</style>
